import { Price, PriceInformation } from '@shared/models/price.model';
import { SubscriptionOffering } from '@shared/models/subscription-offering.model';
import { PcmProduct } from './pcm-product.model';

export class VoiceAllowedChangeInfo {
  changeInfo: VoiceChangeInfo;
  subscriptionOffering: VoiceSubscriptionOffering;
}

export enum GiftingCapability {
  DonateAndReceive = 'DonateAndReceive',
  DonateOnly = 'DonateOnly',
  ReceiveOnly = 'ReceiveOnly',
  NoGifting = 'NoGifting',
  Unknown = 'Unknown',
}

export class VoiceDataInfo {
  dataOnNet: number;
  dataOffNet: number;
  dataEU: number;
  hasRollover: boolean;
  giftingCapability: GiftingCapability;
}

export class VoiceInfo {
  smsPrice: PriceInformation;
  smsIncluded: number;
  mmsPrice: PriceInformation;
  mmsIncluded: number;
  callPrice: PriceInformation;
  callInitiationFee: PriceInformation;
  minutesIncluded: number;
}

export enum VoiceSubscriptionType {
  Regular = 'Regular',
  Trial = 'Trial',
  BliKjent = 'BliKjent',
  Weekly = 'Weekly',
  IceJunior = 'IceJunior',
  IceJuniorPremium = 'IceJuniorPremium',
  IceSenior = 'IceSenior',
  Proff = 'Proff',
  IceTeen = 'IceTeen',
  IceYoung = 'IceYoung',
  BTL = 'BTL',
  MbbWeekly = 'MbbWeekly',
  Flex = 'Flex',
  IcePlus = 'IcePlus',
  PayAsYouGo = 'PayAsYouGo',
  Unlimited = 'Unlimited',
  Unknown = 'Unknown',
  Freemium = 'Freemium',
}

export class VoiceSubscriptionOffering extends SubscriptionOffering {
  upperAgeLimit?: number;
  lowerAgeLimit?: number;
  voiceInfo?: VoiceInfo;
  dataInfo?: VoiceDataInfo;
  subscriptionType?: VoiceSubscriptionType;
  pcmProducts?: PcmProduct[];
}

export class VoiceChangeInfo {
  triggersBreakageFee: boolean;
  remainingBreakageFee: Price;
}
